import { BreadCrumbModel } from '@/models/breadcrumb';
import i18n from '@/plugins/i18n';

const Breadcrumbs = {
  test: [{
    text: i18n.t('home'),
    href: '/applications/landing'
  },
  {
    text: i18n.t('verificationServices'),
    href: '/applications/landing/verification-services'
  }
  ] as BreadCrumbModel[],
};

export default Breadcrumbs;
